var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"img_code",attrs:{"src":_vm.imgCodeURL,"align":"absmiddle","title":"看不清，请点击刷新","width":_vm.width,"height":_vm.height},on:{"click":_vm.changeImgCode}})
}
var staticRenderFns = []

export { render, staticRenderFns }